import { AppButton } from '@components/AppComponents'
import { AppTable } from '@components/table'
import { ApiService } from '@services/ApiService'
import { Spin } from 'antd'
import { observer } from 'mobx-react'
import { useEffect, useMemo, useState } from 'react'

import MaxFileSizeSettingModal from './MaxFileSizeSettingModal'

const FileManagementPage = () => {
  const [loading, setLoading] = useState(true)

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [data, setData] = useState([])

  const [editingItem, setEditingItem] = useState(null)
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const resp = await ApiService.FileManager.GetAll(
        {},
        {
          disableCache: true,
        }
      )
      setData(resp.data)
    } finally {
      setLoading(false)
    }
  }

  const fileColumns = useMemo(
    () => [
      {
        title: 'Tenant Name',
        Cell: (_, record) => <span>{record.tenantName}</span>,
      },
      {
        title: 'Used Storage',
        Cell: (_, record) => (
          <span>{Number(record.totalFileSizeInGB).toFixed(1)} GB</span>
        ),
      },
      {
        title: 'Storage Limit',
        Cell: (_, record) => <span>{record.storageLimitInGB} GB</span>,
      },
    ],
    []
  )

  const contextMenu = useMemo(() => {
    return [
      {
        title: 'Set Storage Limit',
        action: record => {
          setEditingItem(record)
          setIsOpenModal(true)
        },
      },
    ]
  }, [])

  return (
    <Spin spinning={loading}>
      <AppTable.FilterContainer
        handleRefresh={() => {}}
        handleReset={() => {}}
        handleSearch={() => {}}
      >
        <AppTable.FilterHeader>
          <AppButton color="green" onClick={() => fetchData()}>
            Refresh
          </AppButton>
        </AppTable.FilterHeader>
      </AppTable.FilterContainer>
      <AppTable
        tableKey="file-management-table"
        columns={fileColumns}
        contextMenu={contextMenu}
        data={data}
        totalCount={data.length}
        hasPaginate={false}
      />
      {isOpenModal && (
        <MaxFileSizeSettingModal
          tenantId={editingItem.tenantId}
          storageLimit={editingItem.storageLimitInGB}
          onClose={() => {
            setIsOpenModal(false)
            fetchData()
          }}
        />
      )}
    </Spin>
  )
}

export default observer(FileManagementPage)
